import {
    RegistrationFlow,
    RegistrationFlowStep,
} from '@rhg/hooks/use-registration-context/types';
import { clearSAMLStorage } from '@rhg/utils/sso';
import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import { useCallback } from 'react';

export const RegistrationDialogOpenQueryKey = 'rdo';

export function useRegistrationDialog() {
    const { query, replace, pathname } = useRouter();

    const isRegistrationDialogOpen =
        query[RegistrationDialogOpenQueryKey] === 'true';
    const registrationDialogFlow = query.registrationFlow as RegistrationFlow;
    const registrationDialogStep = query.currentStep as RegistrationFlowStep;

    const showRegistrationDialog = useCallback(
        async (props?: {
            currentStep?: RegistrationFlowStep;
            registrationFlow?: RegistrationFlow;
            forcedQuery?: ParsedUrlQuery;
            forcedPathname?: string;
        }) =>
            replace(
                {
                    pathname: props?.forcedPathname || pathname,
                    query: {
                        ...query,
                        ...props?.forcedQuery,
                        [RegistrationDialogOpenQueryKey]: 'true',
                        currentStep:
                            props?.currentStep ??
                            RegistrationFlowStep.AccessCode,
                        registrationFlow:
                            props?.registrationFlow ??
                            RegistrationFlow.ExistingRegistration,
                    },
                },
                undefined,
                { shallow: true }
            ),
        [pathname, query, replace]
    );

    const closeRegistrationDialog = useCallback(async () => {
        if (!isRegistrationDialogOpen) {
            return;
        }
        clearSAMLStorage();
        const {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            [RegistrationDialogOpenQueryKey]: _,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            currentStep,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            registrationFlow,
            ...replacementQuery
        } = query;
        return replace(
            {
                pathname,
                query: replacementQuery,
            },
            undefined,
            { shallow: true }
        );
    }, [isRegistrationDialogOpen, pathname, query, replace]);

    return {
        showRegistrationDialog,
        closeRegistrationDialog,
        isRegistrationDialogOpen,
        registrationDialogFlow,
        registrationDialogStep,
    };
}
